import Icon from "@ant-design/icons";

const icon = () => (
  <svg
    height="1em"
    viewBox="0 -6 512 511"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m319.132812 12.972656h-214.898437c-18.472656 0-33.496094 15.023438-33.496094 33.496094v419.832031c0 18.46875 15.023438 33.496094 33.496094 33.496094h214.898437c18.472657 0 33.5-15.027344 33.5-33.496094v-419.832031c0-18.472656-15.027343-33.496094-33.5-33.496094zm0 0"
      fill="#fff4f1"
    />
    <path
      d="m319.132812 12.972656h-24.085937c18.472656 0 33.5 15.023438 33.5 33.496094v419.832031c0 18.46875-15.027344 33.496094-33.5 33.496094h24.085937c18.472657 0 33.5-15.027344 33.5-33.496094v-419.832031c0-18.472656-15.027343-33.496094-33.5-33.496094zm0 0"
      fill="#ecedef"
    />
    <path
      d="m352.632812 93.757812v-47.289062c0-18.46875-15.027343-33.496094-33.5-33.496094h-214.898437c-18.472656 0-33.496094 15.027344-33.496094 33.496094v47.289062zm0 0"
      fill="#d0cfd1"
    />
    <path
      d="m319.132812 12.972656h-24.085937c18.472656 0 33.5 15.023438 33.5 33.496094v47.289062h24.085937v-47.289062c0-18.472656-15.027343-33.496094-33.5-33.496094zm0 0"
      fill="#9c9b9d"
    />
    <path
      d="m70.738281 419.011719v47.289062c0 18.46875 15.027344 33.496094 33.496094 33.496094h214.902344c18.46875 0 33.496093-15.027344 33.496093-33.496094v-47.289062zm0 0"
      fill="#d0cfd1"
    />
    <path
      d="m328.546875 466.300781c0 18.46875-15.027344 33.496094-33.5 33.496094h24.085937c17.316407 0 31.605469-13.207031 33.324219-30.074219.117188-1.125.175781-2.265625.175781-3.421875v-47.292969h-24.085937zm0 0"
      fill="#9c9b9d"
    />
    <path
      d="m495.441406 154.644531h-275.917968c-9.128907 0-16.558594 7.425781-16.558594 16.558594v169.601563c0 9.128906 7.429687 16.558593 16.558594 16.558593h275.917968c9.132813 0 16.558594-7.429687 16.558594-16.558593v-169.601563c0-9.132813-7.429688-16.558594-16.558594-16.558594zm0 0"
      fill="#4890e3"
    />
    <path
      d="m495.441406 154.644531h-23.082031c9.132813 0 16.558594 7.425781 16.558594 16.558594v169.601563c0 9.128906-7.425781 16.558593-16.558594 16.558593h23.082031c9.132813 0 16.558594-7.429687 16.558594-16.558593v-169.601563c0-9.132813-7.429688-16.558594-16.558594-16.558594zm0 0"
      fill="#2970d6"
    />
    <path
      d="m407.898438 188.457031c-19.636719 0-35.609376 15.972657-35.609376 35.609375 0 19.632813 15.972657 35.609375 35.609376 35.609375 19.632812 0 35.605468-15.976562 35.605468-35.609375 0-19.636718-15.972656-35.609375-35.605468-35.609375zm0 0"
      fill="#f8c03c"
    />
    <path
      d="m444.941406 188.457031c-19.632812 0-35.609375 15.972657-35.609375 35.609375 0 19.632813 15.976563 35.609375 35.609375 35.609375 19.636719 0 35.609375-15.976562 35.609375-35.609375 0-19.636718-15.972656-35.609375-35.609375-35.609375zm0 0"
      fill="#f9e075"
    />
    <path
      d="m320.484375 190.480469h-65.808594c-9.132812 0-16.558593 7.429687-16.558593 16.558593v34.050782c0 9.128906 7.425781 16.558594 16.558593 16.558594h65.808594c9.132813 0 16.5625-7.429688 16.5625-16.558594v-34.050782c0-9.128906-7.429687-16.558593-16.5625-16.558593zm0 0"
      fill="#fb900d"
    />
    <path
      d="m468.078125 272.75h-218.398437c-9.132813 0-16.558594 7.429688-16.558594 16.558594v11.242187c0 9.128907 7.425781 16.558594 16.558594 16.558594h218.398437c9.132813 0 16.5625-7.429687 16.5625-16.558594v-11.242187c0-9.128906-7.429687-16.558594-16.5625-16.558594zm0 0"
      fill="#91bcee"
    />
    <path
      d="m210.492188 383.8125c-4.15625 0-7.527344-3.371094-7.527344-7.527344v-239.976562c0-4.15625 3.371094-7.527344 7.527344-7.527344s7.527343 3.371094 7.527343 7.527344v239.976562c0 4.15625-3.371093 7.527344-7.527343 7.527344zm0 0"
      fill="#d0cfd1"
    />
    <path
      d="m73.640625.5c-40.605469 0-73.640625 33.035156-73.640625 73.640625 0 40.601563 33.035156 73.636719 73.640625 73.636719 40.601563 0 73.636719-33.035156 73.636719-73.636719 0-40.605469-33.035156-73.640625-73.636719-73.640625zm0 0"
      fill="#00bf9e"
    />
    <path
      d="m73.640625.5c-3.929687 0-7.78125.316406-11.542969.910156 35.140625 5.558594 62.097656 36.050782 62.097656 72.730469 0 36.675781-26.957031 67.167969-62.097656 72.726563 3.761719.59375 7.613282.910156 11.542969.910156 40.601563 0 73.636719-33.035156 73.636719-73.636719 0-40.605469-33.035156-73.640625-73.636719-73.640625zm0 0"
      fill="#00a983"
    />
    <path
      d="m67.265625 96.929688c-.085937 0-.175781-.003907-.261719-.007813-2.191406-.074219-4.238281-1.101563-5.609375-2.808594l-15.441406-19.230469c-2.601563-3.242187-2.085937-7.980468 1.15625-10.582031 3.242187-2.601562 7.976563-2.085937 10.582031 1.15625l9.972656 12.417969 22.261719-24.105469c2.820313-3.054687 7.582031-3.242187 10.632813-.421875 3.054687 2.820313 3.246094 7.582032.425781 10.636719l-28.191406 30.523437c-1.425781 1.546876-3.433594 2.421876-5.527344 2.421876zm0 0"
      fill="#fff4f1"
    />
  </svg>
);

const IconPayment = (props) => <Icon component={icon} {...props} />;

export default IconPayment;
